import Moment from 'moment';

export const money = (value) => {
    const n = Number(value) || 0;
    return (n < 0 ? '-$' : '$') + Math.abs(n).toFixed(2);
};

// Same payroll math as the POS Payroll screen (pos/src/pages/Payout).
// commission = service commission - (service + ticket discounts)
// a guaranteed per-day salary tops the total up when commission + tips is below it.
export const payrollTotals = (emp, fromDate, toDate) => {
    const e = emp || {};
    const service = Number(e.ServiceAmount) || 0;
    const tips = Number(e.Tips) || 0;
    const discounts = (Number(e.Discount) || 0) + (Number(e.TicketDiscount) || 0);
    const commission = service - discounts;
    const earned = commission + tips;

    const perDay = Number(e.per_day) || 0;
    const days = Math.max(0, Moment(toDate).startOf('day').diff(Moment(fromDate).startOf('day'), 'days') + 1);
    const salaryOffset = Math.max(0, perDay * days - earned);
    const netPayable = earned + salaryOffset;

    const pct = (v) => (Number(v) || 0) / 100;
    const payCash = commission * pct(e.mCashPercentage);
    const payCheck = commission * pct(e.mCheckPercentage);
    const tipsCash = tips * pct(e.mTipsCashPercentage);
    const tipsCheck = tips * pct(e.mTipsCheckPercentage);

    return {
        service, tips, discounts, commission, perDay, days, salaryOffset, netPayable,
        hasSalary: perDay > 0,
        payCash, payCheck, tipsCash, tipsCheck,
        finalCash: payCash + tipsCash,
        finalCheck: payCheck + tipsCheck,
    };
};

// Price of services on voided tickets, each service counted once (as on the POS).
export const voidedServiceTotal = (rows) => {
    const counted = new Set();
    let total = 0;
    (rows || []).forEach((row) => {
        const key = String(row.ticketServiceId);
        if (counted.has(key)) return;
        const payments = (row.ticket && row.ticket.ticketpayments) || [];
        if (payments.some((p) => p.txnStatus === 'Voided') && Number(row.servicePrice) > 0) {
            total += Number(row.servicePrice);
            counted.add(key);
        }
    });
    return total;
};

// [label, chipColor] pairs for a ticket's payment / batch status (as on the POS).
export const ticketStatusLabels = (ticket) => {
    const payments = (ticket && ticket.ticketpayments) || [];
    if (payments.length === 0) return [];
    let paid = 0;
    let status = 'Paid';
    let batched = 0;
    let cash = 0;
    payments.forEach((p) => {
        paid += Number(p.ticketPayment) || 0;
        if (Number(p.ticketPayment) < 0 && p.txnStatus === 'Refunded') status = 'Refunded';
        if (Number(p.ticketPayment) < 0 && p.txnStatus === 'Voided') status = 'Voided';
        if (p.batchId !== null && p.batchId !== undefined && p.batchId !== '') batched += 1;
        if (p.payMode === 'cash') cash += 1;
    });
    const due = Number(ticket.ticketTotalAmount) - paid;
    const labels = [];
    if (due > 0.005 && status !== 'Refunded' && status !== 'Voided') labels.push(['Partially Paid', 'warning']);
    else if (due > 0.005 && paid > 0 && status === 'Voided') labels.push(['Partially Voided', 'warning']);
    else if (due > 0.005 && paid > 0 && status === 'Refunded') labels.push(['Partially Refunded', 'warning']);
    else if (status === 'Voided') labels.push(['Voided', 'error']);
    else if (status === 'Refunded') labels.push(['Refunded', 'error']);
    else if (Math.abs(due) <= 0.005) labels.push(['Paid', 'success']);

    const nonCash = payments.length - cash;
    if (nonCash > 0 && batched === nonCash) labels.push(['Batch Settled', 'primary']);
    else if (batched > 0 && batched < nonCash) labels.push(['Partially Batch Settled', 'info']);
    return labels;
};
